// @flow
import React, {Component} from 'react';
import './AboutModal.css';

export default class AboutModal extends Component {
  render() {
    return (
      <div className="aboutModal">
        <h2>About the Real-Time Debate Scorecard</h2>
        <p>
          DigitalCandy has taken the data streams of Twitter and Instagram during the election and run sentiment analysis on it by state.
          Watch the real time sentiment analysis of the social web for the debate and see the states respond in realtime to the candidates' actions and words.
        </p>
        <p>
          For more information, contact <a href="mailto:debate@digitalcandy.com">debate@digitalcandy.com</a>.
        </p>
        <p>
          The Real-Time Debate Scorecard is brought to you by:
          <ul>
            <li><a href="https://www.linkedin.com/in/michael-st-%C2%A0john-b18b721">Mike St. John</a>, <a href="https://digitalcandy.com/">DigitalCandy</a></li>
            <li><a href="https://strml.net">Samuel Reed</a>, <a href="https://www.bitmex.com/">BitMEX</a></li>
            <li><a href="https://www.linkedin.com/in/seanperkins1">Sean Perkins</a>, <a href="http://www.mobility-labs.com/">Mobility Labs</a></li>
          </ul>
        </p>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/AboutModal.js
 **/